'use strict';

var React = require('react');
var reactIcons = require('@sravni/react-icons');
var reactUtils = require('@sravni/react-utils');
var Icon = require('../../Icon/src/Icon.js');
var Progress = require('../../Progress/src/Progress.js');
var Space = require('../../Space/src/Space.js');
require('../../Typography/src/Heading.js');
require('../../Typography/src/Link.js');
require('../../Typography/src/ListItem.js');
require('../../Typography/src/OrderedList.js');
var Text = require('../../Typography/src/Text.js');
require('../../Typography/src/UnorderedList.js');
var Uploader_module = require('../styles/Uploader.module.less.js');

/**
 * @description Uploader component.
 *
 * @component
 * @example
 * ```jsx
 * <Uploader.Item key={fileKey} file={file}/>
 * ```
 */
const UploaderItem = React.forwardRef((props, ref) => {
    const { file, progressPercent, errorMessage, filePreview, onRemove } = props;
    const [preview, setPreview] = React.useState('');
    const cx = reactUtils.useStyles(Uploader_module.default);
    const classNames = cx('uploader-item', {
        error: errorMessage,
    });
    const textSpace = progressPercent ? 8 : 2;
    const fileIcon = React.useMemo(() => {
        if (errorMessage) {
            return (React.createElement(Icon.Icon, { size: 20 },
                React.createElement(reactIcons.Warning, null)));
        }
        return (React.createElement(React.Fragment, null,
            filePreview && React.createElement("img", { className: cx('uploader-preview'), src: filePreview, alt: "preview" }),
            preview ? (React.createElement("img", { className: cx('file-preview', { mobile: filePreview }), src: preview, alt: "preview" })) : (React.createElement(Icon.Icon, { className: cx('file-icon', { mobile: filePreview }), size: 20, shape: "round", background: "light" },
                React.createElement(reactIcons.File, null)))));
    }, [errorMessage, preview, filePreview, cx]);
    const handleRemove = React.useCallback((e) => {
        e.stopPropagation();
        onRemove?.(file);
    }, [file, onRemove]);
    React.useEffect(() => {
        if (!file.type.match('image/*')) {
            setPreview('');
        }
        else {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = () => reader.result && setPreview(reader.result.toString());
        }
    }, [file]);
    return (React.createElement(Space.Space, { ref: ref, "data-qa": "UploaderItem", size: 12, align: "center", className: cx(classNames), onClick: (e) => {
            e.stopPropagation();
        } },
        fileIcon,
        React.createElement(Space.Space, { size: textSpace, direction: "vertical", className: cx('text-container') },
            React.createElement(Text.Text, { size: 14, strong: true, truncate: true }, file.name),
            progressPercent && React.createElement(Progress.Progress, { percent: progressPercent }),
            errorMessage && React.createElement(Text.Text, { size: 12 }, errorMessage)),
        !errorMessage && onRemove && (React.createElement(Icon.Icon, { size: 20, icon: React.createElement(reactIcons.Trash, null), className: cx('remove-icon'), onClick: handleRemove }))));
});
UploaderItem.displayName = 'UploaderItem';

exports.UploaderItem = UploaderItem;
//# sourceMappingURL=UploaderItem.js.map
